import { gql } from '@apollo/client';

export * from './assetsUpdate.mutation.generated';

export const ASSETS_UPDATE = gql`
  mutation assetsUpdate($assetIds: [ID!]!, $assetParams: AssetsUpdateParams!) {
    assetsUpdate(input: { assetIds: $assetIds, assetParams: $assetParams }) {
      success
      errors
    }
  }
`;
